import React from "react";

function DateAndTimeChipMobile(props) {
  return <div className="date-and-time-chip-mobile">{props.date}</div>;
}

export default DateAndTimeChipMobile;
